import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const UpgradeGate = ({ message }) => (
  <div className="rounded-xl border bg-card p-8 text-center" data-testid="upgrade-gate">
    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent/15 text-accent">
      <Lock className="h-6 w-6" />
    </div>
    <h3 className="font-heading text-lg font-semibold">Recurso indisponível no seu plano</h3>
    <p className="mx-auto mt-1 max-w-md text-sm text-muted-foreground">
      {message || "Faça upgrade para desbloquear este recurso."}
    </p>
    <Button asChild className="mt-5" data-testid="upgrade-gate-btn">
      <Link to="/configuracoes?tab=assinatura">Ver planos</Link>
    </Button>
  </div>
);
